import {
    EmployeeNodeModel,
    ModalProps,
    WorkshiftSchedulingModel,
} from '../../models';

export const MODAL_PROPS_EMPTY: ModalProps = {
    startDate: '',
    endDate: '',
    employee: {} as EmployeeNodeModel[],
    workshiftId: 0,
    id: [],
    workshift: {} as WorkshiftSchedulingModel,
    isExceptional: false,
};
